import * as Preact from "preact"

import * as PlotSteps from "@fae/source/data/plot/steps.js"
import {Power, Element, Keyword} from "@fae/source/data/games/ember/views/Description.jsx"

import elements from "@fae/source/data/elements.js"
import items from "@fae/source/data/games/ember/items.jsx"

const units = {}

const PASSIVES = {
    "counter": {
        "title": "Just",
        "isHidden": true,
        "element": "earth",
        "color": "transparent",
        "description": () => {
            return (
                <span>+2 power to axes during counterattacks.</span>
            )
        },
        "powerboost": ({stage, unit, item}) => {
            if(stage.turn.number % 2 == 1 && item?.weaponType == "axe") return +20
        }
    },
    "tempo": {
        "title": "Passion",
        "isHidden": true,
        "element": "fire",
        "color": "transparent",
        "description": () => {
            return (
                <span>+1 power to swords during your first turn.</span>
            )
        },
        "powerboost": ({stage, unit, item}) => {
            if(stage.turn.number == 0 && item?.weaponType == "sword") return +10
        }
    },
    "careful": {
        "title": "Careful",
        "isHidden": true,
        "element": "water",
        "color": "transparent",
        "description": () => {
            return (
                <span>+1 power to bows if you have taken no damage.</span>
            )
        },
        "powerboost": ({stage, unit, item}) => {
            if(unit.health == unit.maxhealth && item?.weaponType == "bow") return +10
        }
    },
    "embering": {
        "title": "Embering",
        "element": "fire",
        "isHiddenUnlessActive": true,
        "color": "red",
        "description": () => {
            return (
                <span>+10 power while dying.</span>
            )
        },
        "powerboost": ({stage, unit, item}) => {
            if(unit.deathTimer > 0) return +100
        }
    }
}

const DEFAULT_MONSTER = {
    "maxhealth": 30,

    "affiliation": "bad",
    "state": "aggroed",

    "title": "???",
    // "subtitle": "Monstrosity",

    "spriteSize": "4x3",
    "weaponImageKey": "hidden",
    "weaponAudioKey": "Unit:Attack:Monster",

    "items": [
        {...items["basic-attack"], "element": "water", "power": 10},
        {...items["basic-attack"], "element": "water", "power": 10},
        {...items["basic-attack"], "element": "water", "power": 10},
        {...items["basic-attack"], "element": "water", "power": 10},
        {...items["basic-attack"], "element": "water", "power": 20},
        {...items["basic-attack"], "element": "water", "power": 20},
    ],
}

units["ember/kullervo"] = {
    "key": "kullervo",
    "name": "Kullervo",
    "number": "III",
    "jobName": "The Woodsman",
    "description": "Wields swords and axes.",
    "affiliation": "good",
    "hasSlowDeath": true,

    "maxhealth": 90,
    // "power": 5,
    "defense": 3,
    "moverange": 2,
    "skillKeys": [
        "push",
        "ember/kindle",
        "ember/harvest",
        "ember/recruit",
    ],

    "equippableWeaponTypes": ["axe", "sword", "shield", "fist"],
    "items": {
        "0": {...items["firekeeper-greataxe"], "power": 20},
        "2": {...items["burning-blade"], "power": 20},
    },
    "defaultItems": {
        "0": {...items["basic-strike"], "power": 10},
        "1": {...items["basic-strike"], "power": 10},
        "2": {...items["basic-strike"], "power": 10},
        "3": {...items["basic-strike"], "power": 10},
        "4": {...items["basic-strike"], "power": 10},
        "5": {...items["basic-strike"], "power": 10},
    },
    "passives": [
        PASSIVES["counter"],
        PASSIVES["embering"],
    ],

    "scripts": {
        "death": [
            // PlotSteps.KillAudio({"label": "music"}),
            // PlotSteps.KillAudio({"label": "ambience"}),
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            PlotSteps.ShudderUnit({"unitKey": "kullervo"}),
            "...THE WOODSMAN HAS TAKEN A FATAL HIT",
            "KULLERVO: ...",
        ],
        "slowdeath": [
            PlotSteps.PlayAudio("Ember:Music:Death:Kullervo"),
            "KULLERVO: Finally.."
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "static": require("@fae/source/assets/images/ember-tactics/sprites/characters/sprites-kullervo-static.png"),
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-20-head-0002.png")},
                            {"time": 3000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-20-head-0000.png")},
                            {"time": 3100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-20-head-0001.png")},
                            {"time": 3200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-30-body.png")},
                {"stack": 40, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-40-legs.png")},
                {"stack": 110, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-outline-10-body.png")},
                {"stack": 120, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-outline-20-head.png")},
                {"stack": 130, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-outline-30-body.png")},
                {"stack": 140, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kullervo/sprite-kullervo-outline-40-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraitAnchor": {"x": -6.4, "y": -4.1},
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-kullervo-radiance.png"),
    },
}

units["ember/mara"] = {
    "jobName": "The Hedgewitch",
    "name": "Mara",
    "number": "II",
    "description": "Wields staves and daggers.",
    "affiliation": "good",
    "hasSlowDeath": true,

    "maxhealth": 70,
    // "power": 10,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "ember/kindle",
        "ember/harvest",
        "ember/recruit",
        "push",
    ],

    "equippableWeaponTypes": ["staff", "sword", "shield", "fist"],
    "items": {
        "0": {...items["kindling-staff"], "power": 20},
        "2": {...items["ritual-dagger"], "power": 10},
    },
    "defaultItems": {
        "0": {...items["basic-strike"], "power": 10},
        "1": {...items["basic-strike"], "power": 10},
        "2": {...items["basic-shield"], "power": 10},
        "3": {...items["basic-shield"], "power": 10},
        "4": {...items["basic-strike"], "power": 10},
        "5": {...items["basic-strike"], "power": 10},
    },
    "passives": [
        PASSIVES["counter"],
        PASSIVES["embering"],
    ],

    "scripts": {
        "death": [
            // PlotSteps.KillAudio({"label": "music"}),
            // PlotSteps.KillAudio({"label": "ambience"}),
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            PlotSteps.ShudderUnit({"unitKey": "mara"}),
            "...THE HEDGEWITCH HAS TAKEN A FATAL HIT",
            "MARA: ... #expression:dying",
        ],
        "slowdeath": [
            PlotSteps.PlayAudio("Ember:Music:Death:Mara"),
            "MARA: The hearthlands are real. #expression:dead1",
            "MARA: I will not reach them with you. #expression:dead1",
            "MARA: But know they are real, and they are warm. #expression:dead2",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        // "static": require("@fae/source/assets/images/ember-tactics/sprites/characters/sprites-mara-static.png"),
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-30-legs.png")},
                {"stack": 110, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-outline-10-body.png")},
                {"stack": 120, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-outline-20-head.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-outline-30-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        },
        "embering": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-30-legs.png")},

                // these are now masked
                {"stack": 110, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-outline-10-body.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 120, "type": "head", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-outline-20-head.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 130, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-outline-30-legs.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},

                // added these
                {"stack": 200, "animation": require("@fae/source/assets/images/ember-tactics/sprites/embering/active/index.js").default},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-glow.png")},

                // added these
                {"stack": 10 - 1, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-10-body.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 20 - 1, "type": "head", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-20-head-0000.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 30 - 1, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/mara/sprite-mara-30-legs.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
            ],
        },
    },
    "portraitAnchor": {
        "x": -5.7,
        "y": -4.8,
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-mara.png"),
        "dying": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-mod-sweat.png")},
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-exp-hurt.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-fire-embering.png")},

            {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-orangelight.png"), "opacity": 0.25, "blendmode": "overlay"},
            {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-orangelight.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
        "dead1": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-mod-sweat.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-fire-fading.png")},

            {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
            {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
        "dead2": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-mod-sweat.png")},
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-mod-closedhappysad.png")},
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-exp-happy.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-fire-fading.png")},

            {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
            {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Mara/portraits-ember-mara-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
    },
}

units["ember/ashe"] = {
    "name": "Ashe",
    "number": "XIV",
    "jobName": "The Wanderbard",
    "description": "Wields swords and bows.",
    "affiliation": "good",
    "hasSlowDeath": true,

    "maxhealth": 80,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "ember/kindle",
        "ember/harvest",
        "ember/recruit",
        "suplex",
    ],

    "equippableWeaponTypes": ["sword", "bow", "shield", "fist", "song"],
    "items": {
        "0": {...items["burning-blade"], "power": 20},
        "2": {...items["lute"]},
    },
    "defaultItems": {
        "0": {...items["basic-strike"], "power": 10},
        "1": {...items["basic-strike"], "power": 10},
        "2": {...items["basic-strike"], "power": 10},
        "3": {...items["basic-strike"], "power": 10},
        "4": {...items["basic-strike"], "power": 10},
        "5": {...items["basic-strike"], "power": 10},
    },
    "passives": [
        PASSIVES["tempo"],
        PASSIVES["embering"],
    ],

    "scripts": {
        "death": [
            // PlotSteps.KillAudio({"label": "music"}),
            // PlotSteps.KillAudio({"label": "ambience"}),
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            PlotSteps.ShudderUnit({"unitKey": "ashe"}),
            "...THE WANDERBARD HAS TAKEN A FATAL HIT.",
            "ASHE: It's but a scratch. #expression:dying",
        ],
        "slowdeath": [
            PlotSteps.PlayAudio("Ember:Music:Death:Ashe"),
            "ASHE: All right, we'll call it a draw. #expression:dead",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        // "static": require("@fae/source/assets/images/ember-tactics/sprites/characters/sprites-ashe-static.png"),
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-30-body.png")},
                {"stack": 40, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-40-legs.png")},
                {"stack": 110, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-10-body.png")},
                {"stack": 120, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-20-head.png")},
                {"stack": 130, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-30-body.png")},
                {"stack": 140, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-40-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        },
        "embering": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-30-body.png")},
                {"stack": 40, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-40-legs.png")},

                // these are now masked
                {"stack": 110, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-10-body.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 120, "type": "head", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-20-head.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 130, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-30-body.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 140, "type": "legs", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-outline-40-legs.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},

                // added these
                {"stack": 200, "animation": require("@fae/source/assets/images/ember-tactics/sprites/embering/active/index.js").default},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-glow.png")},

                // added these
                {"stack": 10 - 1, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-10-body.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 20 - 1, "type": "head", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-20-head-0000.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 30 - 1, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-30-body.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 40 - 1, "type": "legs", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/ashe/sprite-ashe-40-legs.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
            ],
        },
    },
    "portraitAnchor": {
        "x": -5.7,
        "y": -5.4,
    },
    "portraits": {
        "neutral": [
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
        ],
        "angry": [
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-angry.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
        ],
        "happy": [
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-happy.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
        ],
        "hurt": [
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-hurt.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
        ],
        "pouty": [
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-pouty.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
        ],
        "sad": [
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-sad.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
        ],
        "dying": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-mod-sweat.png")},
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-happy.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-fire-embering.png")},

            // {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-orangelight.png"), "opacity": 0.25, "blendmode": "overlay"},
            // {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-orangelight.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
        "dead": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-mod-sweat.png")},
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-mod-closed.png")},
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-exp-happy.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-fire-fading.png")},

            {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
            {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Ashe/portraits-ember-ashe-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
        // TODO: ashe-no-cloak variants
    },
}

units["ember/gwyn"] = {
    "name": "Gwyn",
    "number": "IX",
    "jobName": "The Hunter",
    "description": "Wields bows and axes.",
    "affiliation": "good",
    "hasSlowDeath": true,

    "maxhealth": 70,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "ember/kindle",
        "ember/harvest",
        "ember/recruit",
        "pull",
    ],

    "equippableWeaponTypes": ["bow", "axe", "shield", "fist"],
    "items": {
        "0": {...items["bone-bow"], "power": 20},
        "2": {...items["firekeeper-greataxe"], "power": 20},
    },
    "defaultItems": {
        // "0": {...items["basic-shield"], "power": 20},
        // "1": {...items["basic-shield"], "power": 20},
        // "2": {...items["basic-shield"], "power": 20},
        // "3": {...items["basic-shield"], "power": 20},
        // "4": {...items["basic-shield"], "power": 20},
        // "5": {...items["basic-shield"], "power": 20},
        "0": {...items["basic-strike"], "power": 10},
        "1": {...items["basic-strike"], "power": 10},
        "2": {...items["basic-strike"], "power": 10},
        "3": {...items["basic-strike"], "power": 10},
        "4": {...items["basic-strike"], "power": 10},
        "5": {...items["basic-strike"], "power": 10},
    },
    "passives": [
        PASSIVES["careful"],
        PASSIVES["embering"],
    ],

    "scripts": {
        "death": [
            // PlotSteps.KillAudio({"label": "music"}),
            // PlotSteps.KillAudio({"label": "ambience"}),
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            PlotSteps.ShudderUnit({"unitKey": "gwyn"}),
            "...THE HUNTER HAS TAKEN A FATAL HIT",
            "GWYN: I'm - I'm sorry. #expression:dying",
        ],
        "slowdeath": [
            PlotSteps.PlayAudio("Ember:Music:Death:Gwyn"),
            "GWYN: Not yet, I'm not-. #expression:dead",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-30-legs.png")},
                {"stack": 110, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-10-body.png")},
                {"stack": 120, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-20-head.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-30-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        },
        "embering": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-10-body.png")},
                {
                    "stack": 20,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0002.png")},
                        ]
                    }
                },
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-30-legs.png")},

                // these are now masked
                {"stack": 110, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-10-body.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 120, "type": "head", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-20-head.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},
                {"stack": 130, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-30-legs.png"), "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-outlinemask.png")},

                // added these
                {"stack": 200, "animation": require("@fae/source/assets/images/ember-tactics/sprites/embering/active/index.js").default},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/embering/fireanim-embering-glow.png")},

                // added these
                {"stack": 10 - 1, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-10-body.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 20 - 1, "type": "head", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0000.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
                {"stack": 30 - 1, "type": "body", "maskimage": require("@fae/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-30-legs.png"), "color": "#ffb88d", "opacity": 0.4, "blendmode": "overlay"},
            ],
        },
    },
    "portraitAnchor": {
        "x": -5.7,
        "y": -4.4,
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn.png"),
        "dying": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-mod-sweat.png")},
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-exp-hurt.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-fire-embering.png")},

            {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-orangelight.png"), "opacity": 0.25, "blendmode": "overlay"},
            {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-orangelight.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
        "dead": [
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-mod-sweat.png")},
            {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-mod-closed.png")},
            {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-exp-sad.png")},
            {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn.png")},
            {"stack": 100, "image": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-fire-fading.png")},

            {"stack": 10, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
            {"stack": 50, "maskimage": require("@fae/source/assets/images/ember-tactics/portraits/Gwyn/portraits-ember-gwyn-fire-embering.png"), "image": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-overlay-blueshadow.png"), "opacity": 0.25, "blendmode": "overlay"},
        ],
    },
}

units["ember/hugo"] = {
    "key": "hugo",
    "jobName": "The Traveler",
    "name": "Hugo",
    "affiliation": "good",
    // "hasSlowDeath": true,

    "maxhealth": 60,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "ember/kindle",
        "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "...HUGO HAS TAKEN A FATAL HIT",
            "HUGO: Bahaha!! A fine blow. Now let me show you mine.",
        ],
        "slowdeath": [
            "HUGO: I am Hugo Ambrosi, Son of Neptar, Weilder of the Hearthaxe, and Knight of the Realm.",
            "HUGO: Let the weapon that felled me be remembered as the AMBROSI-BANE.",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {
                    "stack": 10,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-10-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-10-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-10-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-10-head-0002.png")},
                        ]
                    }
                },
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-20-body.png")},
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-30-legs.png")},
                {"stack": 110, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-outline-10-head.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-outline-20-body.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/hugo/sprite-hugo-outline-30-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-hugo.png"),
    },
}

units["ember/neve"] = {
    "jobName": "The Angler",
    "name": "Neve",
    "affiliation": "good",
    // "hasSlowDeath": true,

    "maxhealth": 40,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "pull",
        "ember/kindle", "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "THE ANGLER HAS TAKEN A FATAL HIT",
            "NEVE: TBD",
        ],
        "slowdeath": [
            "NEVE: TBD",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {
                    "stack": 10,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-10-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-10-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-10-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-10-head-0002.png")},
                        ]
                    }
                },
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-20-body.png")},
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-30-legs.png")},
                {"stack": 40, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-40-head.png")},
                {"stack": 110, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-outline-10-head.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-outline-20-body.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-outline-30-legs.png")},
                {"stack": 140, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/neve/sprite-neve-outline-40-head.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-neve.png"),
    },
}

units["ember/ylfa"] = {
    "key": "ylfa",
    "jobName": "The Wolf Pup",
    "name": "Ylfa",
    "affiliation": "good",
    // "hasSlowDeath": true,

    "maxhealth": 40,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "push",
        "ember/kindle", "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "THE WOLF PUP HAS TAKEN A FATAL HIT",
            "YLFA: :(",
        ],
        "slowdeath": [
            "YLFA: :(((((",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {
                    "stack": 0,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-10-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-10-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-10-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-10-head-0002.png")},
                        ]
                    }
                },
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-20-body.png")},
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-30-legs.png")},
                {"stack": 110, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-outline-10-head.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-outline-20-body.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-outline-30-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-ylfa.png"),
    },
}

units["ember/vasilisa"] = {
    "name": "Vasilisa",
    "jobName": "The Kindly",
    "affiliation": "good",
    // "hasSlowDeath": true,

    "maxhealth": 40,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "ember/kindle", "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "THE KINDLY HAS TAKEN A FATAL HIT",
            "VASILISA: TBD",
        ],
        "slowdeath": [
            "VASILISA: TBD",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-10-head.png")},
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-20-body.png")},
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-30-legs.png")},
                {"stack": 40, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-40-head.png")},
                {"stack": 110, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-outline-10-head.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-outline-20-body.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-outline-30-legs.png")},
                {"stack": 140, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/vasilisa/sprite-vasilisa-outline-40-head.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-vasilisa.png"),
    },
}

units["ember/tariq"] = {
    "jobName": "The Historian",
    "name": "Tariq",
    "affiliation": "good",
    // "hasSlowDeath": true,

    "maxhealth": 30,
    "resistance": 3,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "pull",
        "ember/kindle", "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "THE HISTORIAN HAS TAKEN A FATAL HIT",
            "TARIQ: TBD",
        ],
        "slowdeath": [
            "TARIQ: TBD",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-10-head.png")},
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-20-body.png")},
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-30-legs.png")},
                {"stack": 40, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-40-head.png")},
                {"stack": 110, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-outline-10-head.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-outline-20-body.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-outline-30-legs.png")},
                {"stack": 140, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/tariq/sprite-tariq-outline-40-head.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-tariq.png"),
    },
}

units["ember/kaz"] = {
    "jobName": "The Soldier",
    "name": "Kaz",
    "affiliation": "good",
    // "hasSlowDeath": true,

    "maxhealth": 60,
    "health": 50,
    "defense": 3,
    "moverange": 2,

    "skillKeys": [
        "pull",
        "ember/kindle", "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "THE SOLDIER HAS TAKEN A FATAL HIT",
            "KAZ: TBD",
        ],
        "slowdeath": [
            "KAZ: Finally. Sweet rest.",
            "KAZ: But did I do enough?",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {
                    "stack": 10,
                    "type": "head",
                    "animation": {
                        "frames": [
                            {"time": 0.00, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-10-head-0002.png")},
                            {"time": 2000, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-10-head-0000.png")},
                            {"time": 2100, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-10-head-0001.png")},
                            {"time": 2200, "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-10-head-0002.png")},
                        ]
                    }
                },
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-20-body.png")},
                {"stack": 30, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-30-legs.png")},
                {"stack": 40, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-40-body.png")},
                {"stack": 50, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-50-legs.png")},
                {"stack": 110, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-outline-10-head.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-outline-20-body.png")},
                {"stack": 130, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-outline-30-legs.png")},
                {"stack": 140, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/kaz/sprite-kaz-outline-40-body.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-kaznoghosts.png"),
    },
}

units["ember/crescent"] = {
    "key": "crescent",
    "name": "Crescent",
    "title": "The Crow",
    "affiliation": "good",
    // "hasSlowDeath": true,

    // // COMMENTED OUT FOR THE BOSS FIGHT
    // "maxhealth": 40,
    // "health": 40,
    // "defense": 3,
    // "moverange": 2,

    "skillKeys": [
        "pull",
        "ember/kindle", "ember/harvest",
        "ember/recruit",
    ],

    "scripts": {
        "death": [
            PlotSteps.PlayStinger("Unit:Death:Knell"),
            "THE CROW HAS TAKEN A FATAL HIT",
            "CROW: Not again~",
        ],
        "slowdeath": [
            "CROW: See you on the other side!",
        ]
    },

    "spriteSize": "4x3",
    "animationKey": "breathing",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-10-legs.png")},
                {"stack": 20, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-20-body.png")},
                {"stack": 30, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-30-head.png")},
                {"stack": 40, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-40-legs.png")},
                {"stack": 50, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-50-head.png")},
                {"stack": 110, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-outline-10-legs.png")},
                {"stack": 120, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-outline-20-body.png")},
                {"stack": 130, "type": "head", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-outline-30-head.png")},
                {"stack": 140, "type": "legs", "image": require("@fae/source/assets/images/ember-tactics/sprites/characters/crescent/sprite-crescent-outline-40-legs.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ],
        }
    },
    "portraits": {
        "neutral": require("@fae/source/assets/images/ember-tactics/portraits/portraits-ember-crescent.png"),
    },

    "maxhealth": 90,
    // "properties": ["boss"],
    "properties": ["flipped"],
    // "moverange": 1,
    "attackaudio": "Attack:Slime",
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 20},
        {...items["basic-attack"], "element": "water", "power": 20},
        {...items["basic-attack"], "element": "earth", "power": 20},
        {...items["basic-attack"], "element": "fire", "power": 30},
        {...items["basic-attack"], "element": "water", "power": 30},
        {...items["basic-attack"], "element": "earth", "power": 30},
    ],
}

// TIER 0 //

units["ember/wisp-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Wisp",
    "flavor": "The faceless memory of someone lost.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 3,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["wisp-pentapod"], "element": "fire", "power": 10},
        {...items["wisp-pentapod"], "element": "fire", "power": 10},
        {...items["wisp-pentapod"], "element": "fire", "power": 10},
        {...items["wisp-pentapod"], "element": "fire", "power": 10},
        {...items["wisp-pentapod"], "element": "fire", "power": 10},
        {...items["wisp-pentapod"], "element": "fire", "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wisp-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Wisp",
    "flavor": "The faceless memory of someone lost.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 3,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["wisp-pentapod"], "element": "water", "power": 10},
        {...items["wisp-pentapod"], "element": "water", "power": 10},
        {...items["wisp-pentapod"], "element": "water", "power": 10},
        {...items["wisp-pentapod"], "element": "water", "power": 10},
        {...items["wisp-pentapod"], "element": "water", "power": 10},
        {...items["wisp-pentapod"], "element": "water", "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wisp-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Wisp",
    "flavor": "The faceless memory of someone lost.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 3,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["wisp-pentapod"], "element": "earth", "power": 10},
        {...items["wisp-pentapod"], "element": "earth", "power": 10},
        {...items["wisp-pentapod"], "element": "earth", "power": 10},
        {...items["wisp-pentapod"], "element": "earth", "power": 10},
        {...items["wisp-pentapod"], "element": "earth", "power": 10},
        {...items["wisp-pentapod"], "element": "earth", "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/hare-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Hare",
    "flavor": "Not fast enough.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 3,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "ai": {
        "behaviors": [
            "can attack plants",
            "always attacks plants first"
        ]
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-hare-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/boglet-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Boglet",
    "flavor": "As parasites in life, so parasites in death.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["frog-hop"], "element": "earth", "power": 20},
        {...items["frog-hop"], "element": "earth", "power": 10},
        {...items["frog-hop"], "element": "earth", "power": 10},
        {...items["frog-hop"], "element": "earth", "power": 10},
        {...items["frog-hop"], "element": "earth", "power": 10},
        {...items["frog-hop"], "element": "earth", "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-boglet-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TIER 1 //

units["ember/wolf-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Wolf",
    "flavor": "The wolf pursues, inescapable as fear.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "earth", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "earth", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-wolf-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wolf-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Wolf",
    "flavor": "The wolf pursues, inescapable as fear.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-wolf-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wolf-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Wolf",
    "flavor": "The wolf pursues, inescapable as fear.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-wolf-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/crow-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Crow",
    "flavor": "An omen of death. It is laughing.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,
    "movetype": "flying",

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "fire", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-crow-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/crow-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Crow",
    "flavor": "An omen of death. It is laughing.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,
    "movetype": "flying",

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "water", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-crow-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/crow-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Crow",
    "flavor": "An omen of death. It is laughing.",

    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,
    "movetype": "flying",

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 10, "iconKey": "bird-claw", "title": "Talons"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-crow-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bones-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Sunbleached Bones",
    "flavor": "They tried to eat the sun. The fire ate their flesh.",

    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["bones-sword"], "power": 20},
        {...items["bones-sword"], "power": 20},
        {...items["bones-sword"], "power": 10},
        {...items["bones-throwing-dagger"], "power": 20},
        {...items["bones-throwing-dagger"], "power": 20},
        {...items["bones-throwing-dagger"], "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-bones-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bones-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Sunbleached Bones",
    "flavor": "They tried to eat the sun. The fire ate their flesh.",

    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["bones-axe"], "power": 20},
        {...items["bones-axe"], "power": 20},
        {...items["bones-axe"], "power": 10},
        {...items["bones-throwing-axe"], "power": 20},
        {...items["bones-throwing-axe"], "power": 20},
        {...items["bones-throwing-axe"], "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-bones-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bones-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Sunbleached Bones",
    "flavor": "They tried to eat the sun. The fire ate their flesh.",

    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["bones-spear"], "power": 20},
        {...items["bones-spear"], "power": 20},
        {...items["bones-spear"], "power": 10},
        {...items["bones-bow"], "power": 20},
        {...items["bones-bow"], "power": 20},
        {...items["bones-bow"], "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-bones-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/fish-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Fish",
    "flavor": "She’s tired of granting wishes. Toss a coin in the well, and all you’ll get is teeth.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["fish-fang"], "element": "fire", "power": 20},
        {...items["fish-fang"], "element": "fire", "power": 20},
        {...items["fish-fang"], "element": "fire", "power": 20},
        {...items["fish-fang"], "element": "fire", "power": 10},
        {...items["fish-fang"], "element": "fire", "power": 10},
        {...items["fish-fang"], "element": "fire", "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-pike-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/fish-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Fish",
    "flavor": "She’s tired of granting wishes. Toss a coin in the well, and all you’ll get is teeth.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["fish-fang"], "element": "water", "power": 20},
        {...items["fish-fang"], "element": "water", "power": 20},
        {...items["fish-fang"], "element": "water", "power": 20},
        {...items["fish-fang"], "element": "water", "power": 10},
        {...items["fish-fang"], "element": "water", "power": 10},
        {...items["fish-fang"], "element": "water", "power": 10},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-pike-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TIER 2 //

// buffed
units["ember/bear-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Bear",
    "flavor": "A mother loses her child, and her mind soon after.",

    "health": 80,
    "maxhealth": 120,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "fangs", "title": "Fangs"},
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-bear-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/stag-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Stag",
    "flavor": "A blessed stag coveted by hunters for centuries. One day, even he could evade them no longer.",

    "maxhealth": 60,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "stag-head", "title": "Antlers"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "stag-head", "title": "Antlers"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-stag-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/bull-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Bull",
    // TODO: charging attack!!!
    "flavor": "His blood was said to cure a plague. He laid down his head for the harvest.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "bull-horns", "title": "Horns"},
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "bull-horns", "title": "Horns"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "hoof", "title": "Hoof"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-bull-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/leshy-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Leshy",
    "flavor": "Legend will make even a wise old hermit into the lord of the wood.",

    "maxhealth": 60,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Staff",
    //     "element": "earth",
    //     "attacktype": "magic",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "green-staff",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 30, "attackrange": 2, "iconKey": "wizard-staff", "title": "Staff"},
        {...items["basic-attack"], "element": "earth", "power": 30, "attackrange": 2, "iconKey": "wizard-staff", "title": "Staff"},
        {...items["basic-attack"], "element": "earth", "power": 20, "attackrange": 2, "iconKey": "wizard-staff", "title": "Staff"},
        {...items["basic-attack"], "element": "earth", "power": 20, "attackrange": 2, "iconKey": "wizard-staff", "title": "Staff"},
        {...items["basic-attack"], "element": "earth", "power": 20, "attackrange": 2, "iconKey": "wizard-staff", "title": "Staff"},
        {...items["basic-attack"], "element": "earth", "power": 20, "attackrange": 2, "iconKey": "wizard-staff", "title": "Staff"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-hag-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/woodsman-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Lost Woodsman",
    "flavor": "He spent his life felling trees. In the end the trees felled him.",

    "maxhealth": 60,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "wood-axe", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "wood-axe", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "wood-axe", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "wood-axe", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "wood-axe", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "wood-axe", "title": "Axe"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-woodsman-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/banshee-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Banshee",
    "state": "idle",
    "flavor": "She had a lover once. Now, she is alone, alone, alone.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "items": [
        {...items["basic-attack"], "attackrange": 3, "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "attackrange": 3, "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "attackrange": 3, "element": "water", "power": 20, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "attackrange": 3, "element": "water", "power": 20, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "attackrange": 3, "element": "water", "power": 20, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "attackrange": 3, "element": "water", "power": 20, "iconKey": "drop", "title": "Tear"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-widow-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        },
        "aggroed": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-banshee-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        },
    }
}

// TODO: has not yet been buffed
units["ember/kelpie-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Kelpie",
    "flavor": "Its beauty masks its malice.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": {
    //         "min": 1,
    //         "max": 5,
    //         "orthogonal": true,
    //         "diagonal": false,
    //     },
    //     "power": 20,
    //     "skillKeys": ["charge"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "hoof", "title": "Hoof"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-kelpie-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/kelpie-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Kelpie",
    "flavor": "Its beauty masks its malice.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": {
    //         "min": 1,
    //         "max": 5,
    //         "orthogonal": true,
    //         "diagonal": false,
    //     },
    //     "power": 20,
    //     "skillKeys": ["charge"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "hoof", "title": "Hoof"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-kelpie-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/shepherd-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Lost Shepherd",
    "flavor": "What’s a missing sheep to a flock? Nobody will miss just one.",
    // TODO: should lose sheep after being attacked.

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Staff",
    //     "element": "fire",
    //     "attacktype": "magic",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "red-staff"
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "shepherds-crook", "title": "Staff"},
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "shepherds-crook", "title": "Staff"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "shepherds-crook", "title": "Staff"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "shepherds-crook", "title": "Staff"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "shepherds-crook", "title": "Staff"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "shepherds-crook", "title": "Staff"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd1-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
        // "ember-shepherd1-red": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd1-red.png"),
        // "ember-shepherd2-red": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd2-red.png"),
        // "ember-shepherd3-red": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd3-red.png"),
    },
}

// buffed
units["ember/kikimora-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Kikimora",
    "flavor": "One can only serve an abandoned house so long before their heart leaves them.",

    "maxhealth": 60,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Gun",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "gun",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "kenku-head", "title": "Beak"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "kenku-head", "title": "Beak"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "bird-claw", "title": "Talons"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-kikimora-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/mothman-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Mothman",
    "flavor": "All light is smothered by his wings.",

    "maxhealth": 60,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "ai": {
        "behaviors": [
            "can attack flames",
            "always attacks flames first"
        ]
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-mothman-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/blazing-red"] = {
    ...DEFAULT_MONSTER,
    "title": "The Blazing",
    "flavor": "The fire burns them clean of all but lust for war.",
    // upon death, spawns an ashwraith in its place

    "maxhealth": 120,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["fish-fang"], "element": "fire", "power": 30, "properties": ["pain"], "iconKey": "flame", "title": "Burn"},
        {...items["fish-fang"], "element": "fire", "power": 30, "properties": ["pain"], "iconKey": "flame", "title": "Burn"},
        {...items["fish-fang"], "element": "fire", "power": 20, "properties": ["pain"], "iconKey": "flame", "title": "Burn"},
        {...items["fish-fang"], "element": "fire", "power": 20, "properties": ["pain"], "iconKey": "flame", "title": "Burn"},
        {...items["fish-fang"], "element": "fire", "power": 20, "properties": ["pain"], "iconKey": "flame", "title": "Burn"},
        {...items["fish-fang"], "element": "fire", "power": 20, "properties": ["pain"], "iconKey": "flame", "title": "Burn"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-blazing-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/ashwraith-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Ash Wraith",
    "flavor": "The lifelong weapon knows no peace without a hand to wield it.",

    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "flame", "title": "Burn"},
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "flame", "title": "Burn"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "flame", "title": "Burn"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "flame", "title": "Burn"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "flame", "title": "Burn"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "flame", "title": "Burn"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-ashwraith-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/priestess-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Hollow Priestess",
    "flavor": "They gave and gave, until they had nothing but the hole in her heart. They gave that away, too.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "skillKeys": ["heal"],
    // "primaryItem": {
    //     "name": "Staff",
    //     "element": "water",
    //     "attacktype": "magic",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "blue-staff",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "caduceus", "title": "Staff"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "caduceus", "title": "Staff"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "caduceus", "title": "Staff"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "caduceus", "title": "Staff"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "caduceus", "title": "Staff"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "caduceus", "title": "Staff"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-priestess-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/pirate-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Pirate Captain",
    // "flavor": "He fights for air, and the duckweed holds him down.",

    "maxhealth": 50,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Sword",
    //     "element": "fire",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "sword",
    // },
    "items": [
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "machete", "title": "Sword"},
        {...items["basic-attack"], "element": "fire", "power": 30, "iconKey": "machete", "title": "Sword"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "machete", "title": "Sword"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "machete", "title": "Sword"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "machete", "title": "Sword"},
        {...items["basic-attack"], "element": "fire", "power": 20, "iconKey": "machete", "title": "Sword"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-sailor-red.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/pirate-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Lost Pirate",
    "flavor": "He fights for air, and the duckweed holds him down.",

    "maxhealth": 40,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Spear",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "spear",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "spear-hook", "title": "Spear"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "spear-hook", "title": "Spear"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "spear-hook", "title": "Spear"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "spear-hook", "title": "Spear"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "spear-hook", "title": "Spear"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "spear-hook", "title": "Spear"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-sailor-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/boglord-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Boglord",
    "flavor": "He was a good and honorable liege, they said. He thinks he is, even still.",

    "maxhealth": 100,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Gun",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "gun",
    // },
    "items": [
        {...items["frog-hop"], "element": "earth", "power": 30},
        {...items["frog-hop"], "element": "earth", "power": 30},
        {...items["frog-hop"], "element": "earth", "power": 20},
        {...items["frog-hop"], "element": "earth", "power": 20},
        {...items["frog-hop"], "element": "earth", "power": 20},
        {...items["frog-hop"], "element": "earth", "power": 20},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-boglord-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TIER 3 //

// buffed
units["ember/jester-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Mournful Jester",
    "flavor": "He tells his tearful jokes to a crown on a pile of ash.",

    "maxhealth": 100,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Bow",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "bow",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "drop", "title": "Tear"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "drop", "title": "Tear"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-jester-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// buffed
units["ember/knight-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Green Knight",
    "flavor": "No armor can save a man from death’s dark crescent.",

    "maxhealth": 80,
    "defense": 0,
    "resistance": 0,
    "moverange": 1,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "halberd", "title": "Axe"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-knight-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: BUFFED WAY TOO STRONG! WE'RE USING THIS AS A FINAL BOSS FOR NOW
units["ember/lordandlady-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Lord and Lady",
    "flavor": "Shut your eyes, darling, and the end won’t reach us.",

    "maxhealth": 100,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Axe",
    //     "element": "earth",
    //     "attacktype": "steel",
    //     "attackrange": 1,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "axe",
    // },
    "items": [
        {...items["basic-attack"], "element": "earth", "power": 50, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 40, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 40, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 30, "iconKey": "halberd", "title": "Axe"},
        {...items["basic-attack"], "element": "earth", "power": 20, "iconKey": "halberd", "title": "Axe"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-lordandlady-green.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// TODO: has not yet been buffed
units["ember/rusalka-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Rusalka",
    "flavor": "Come running to the water’s edge, my love / and we’ll dance your days away, / dance your days away, my love, / we’ll dance your days away",

    "maxhealth": 80,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    // "primaryItem": {
    //     "name": "Bow",
    //     "element": "water",
    //     "attacktype": "steel",
    //     "attackrange": 2,
    //     "power": 20,
    //     "skillKeys": ["attack"],
    //     "weaponImageKey": "bow",
    // },
    "items": [
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 30, "iconKey": "triple-claws", "title": "Claws"},
        {...items["basic-attack"], "element": "water", "power": 20, "iconKey": "triple-claws", "title": "Claws"},
    ],

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/monsters/enemy-rusalka-blue.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@fae/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

// MISC //

units["ember/incoming/all"] = {
    "spotTag": "incoming",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["attack"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesmulti1.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/Multi 3/blink main/index.js").default},
            ],
        },
    },
}

units["ember/incoming/fire"] = {
    "spotTag": "incoming",
    "name": "Something Bloody",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["attack"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesred.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/Mono Red/blink main/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/spawner-glow-red.png")},
            ],
        },
    },
}

units["ember/incoming/earth"] = {
    "spotTag": "incoming",
    "name": "Something Rotting",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["attack"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesgreen.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/Mono Green/blink main/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/spawner-glow-green.png")},
            ],
        },
    },
}

units["ember/incoming/water"] = {
    "spotTag": "incoming",
    "name": "Something Ghastly",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["attack"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesblue.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/Mono Blue/blink main/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/enemy-incoming/spawner-glow-blue.png")},
            ],
        },
    },
}

units["ember/campfire"] = {
    "type": "thing",
    "title": "Campfire",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteScale": {"width": 16, "height": 9},
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/campfire/camp-campfire-firelarge-glow.png")},
                {"stack": 20, "image": require("@fae/source/assets/images/ember-tactics/sprites/campfire/camp-campfire-logs.png")},
                {"stack": 30, "image": require("@fae/source/assets/images/ember-tactics/sprites/campfire/camp-campfire-pot.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/campfire/camp-campfire-firelarge-static.png")},
            ],
        }
    },
}

units["ember/torch/1"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 1/Flame/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 1/fireanim-torch1-glow.png")},
            ]
        }
    },
    "data": {
        "flameCount": 1,
    },
}

units["ember/torch/2"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/Torch 2/sprite-item-torch2.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/Torch 2/sprite-item-torch2-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 2/Flame 1/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 2/Glow/fireanim-torch2-glow1.png")},
            ]
        },
        "flame2": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 2/Flame 2/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 2/Glow/fireanim-torch2-glow2.png")},
            ]
        },
    },
    "data": {
        "flameCount": 2,
    },
}

units["ember/torch/3"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/Torch 3/sprite-item-torch3.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/Torch 3/sprite-item-torch3-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 3/Flame 1/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 3/Glow/fireanim-torch3-glow1.png")},
            ]
        },
        "flame2": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 3/Flame 2/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 3/Glow/fireanim-torch3-glow2.png")},
            ]
        },
        "flame3": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 3/Flame 3/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 3/Glow/fireanim-torch3-glow3.png")},
            ]
        },
    },
    "data": {
        "flameCount": 3,
    },
}

units["ember/torch/fancy"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/Torch Fancy/sprite-item-torchfancy.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/torch/Torch Fancy/sprite-item-torchfancy-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Flame 1/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Glow/fireanim-torchfancy-glow1.png")},
            ]
        },
        "flame2": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Flame 2/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Glow/fireanim-torchfancy-glow2.png")},
            ]
        },
        "flame3": {
            "parts": [
                {"stack": 10, "animation": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Flame 3/index.js").default},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Glow/fireanim-torchfancy-glow3.png")},
            ]
        },
    },
    "data": {
        "flameCount": 3,
    },
}

units["ember/flame"] = {
    "role": "flame",

    "affiliation": "none",

    "maxhealth": 30,
    "isHidingHealthbar": true,
    "skillKeys": [
        "ember/burnout"
    ],

    "stack": 10,
    "spriteSize": "4x3",
    "sprites": {
        "idle": require("@fae/source/assets/images/ember-tactics/sprites/flame/Torch 1/Flame/index.js").default,
    },

    // "scripts": {
    //     "death": [
    //         "...THE FLAME DIES",
    //     ],
    // }
}

units["ember/plant/blackberry"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Blackberry",
    "subtitle": "Woodland Berry",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-blackberry.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-blackberry-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/ghostturnip"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Ghost Turnip",
    "subtitle": "Woodland Root",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-turnip.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-turnip-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/kingbolete"] = {
    "type": "thing",
    "role":  "plant",
    "title": "King Bolete",
    "subtitle": "Woodland Fungi",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-kingbolete.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-kingbolete-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/lanternonion"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Lantern Onion",
    "subtitle": "Coastal Root",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-lanternonion.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-lanternonion-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/crookedroot"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Crookedroot",
    "subtitle": "Coastal Root",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-crookedroot.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-crookedroot-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/foxshroom"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Foxshroom",
    "subtitle": "Coastal Fungi",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-foxshroom.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-foxshroom-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/graspgourd"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Graspgourd",
    "subtitle": "Bog Veggie",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-graspergourd.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-graspergourd-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/phantomring"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Phantom Ring",
    "subtitle": "Bog Mushroom",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-phantomring.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-phantomring-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/cravenberry"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Cravenberry",
    "subtitle": "Bog Berry",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-cravenberry.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-cravenberry-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/castlemaiden"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Castle Maiden",
    "subtitle": "Ashland Berry",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-castlemaiden.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-castlemaiden-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/crescentvine"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Crescent Vine",
    "subtitle": "Ashland Veggie",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-crescentvine.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-crescentvine-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/inkcap"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Inkcap",
    "subtitle": "Ashland Mushroom",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoinventory": {
        "items": [
            {
                "name": "Squash",
                "type": "food",
                "image": require("@fae/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
            },
        ],
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-inkcap.png")},
                {"stack": 110, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-inkcap-outline.png")},
                {"stack": 200, "image": require("@fae/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

export default units
